import React, { useState } from 'react'
import clsx from 'clsx'
import { Button, ButtonGroup } from './'

function Tab({ tabs, children, justify, className }) {
    const [activeTab, setActiveTab] = useState(0)
    const activeColor = 'secondary'
    const firstColor = 'transparent'

    return (
        <div
            className={clsx(
                `tabs flex flex-wrap justify-${justify}`,
                className
            )}
        >
            <ButtonGroup color="lightGray">
                {tabs.map((item, idx) => (
                    <Button
                        key={idx}
                        onClick={() => {
                            setActiveTab(idx)
                        }}
                        backgroundColor={
                            idx === activeTab ? activeColor : firstColor
                        }
                        className="p-4"
                    >
                        {item.label}
                    </Button>
                ))}
            </ButtonGroup>
            <div className="w-full basis-full pt-6">{children[activeTab]}</div>
        </div>
    )
}

export default Tab
